import CalendarEvent from "../CalendarEvent";
import Modal, { ModalSizes } from "../../../common/Modal";

const ModalCalendarEvent = ({ isOpen, closeModal, eventId, updateEvents }) => {

    return (
        <Modal isOpen={isOpen} closeModal={closeModal} size={ModalSizes.small} height="auto">
            <CalendarEvent 
                closeModal={closeModal} 
                eventId={eventId} 
                updateEvents={updateEvents}
            />
        </Modal>
    )
}

export default ModalCalendarEvent;